import React from 'react';

/**
 * Follow-up Suggestions Component
 * Generuje chytré follow-up dotazy na základě předchozí odpovědi
 */
export default function FollowUpSuggestions({ lastQuery, lastData, onSelect }) {
  // Generate follow-up suggestions based on context
  const generateSuggestions = () => {
    const suggestions = [];
    const queryLower = lastQuery?.toLowerCase() || '';

    // Device-based follow-ups
    if (!queryLower.includes('mobile') && !queryLower.includes('desktop')) {
      suggestions.push({
        icon: 'smartphone',
        text: 'A co na mobilu?',
        category: 'device'
      });
      suggestions.push({
        icon: 'computer',
        text: 'A jak to vypadá na desktopu?',
        category: 'device'
      });
    }

    // Time-based follow-ups
    if (!queryLower.includes('porovn') && !queryLower.includes('vs')) {
      suggestions.push({
        icon: 'compare_arrows',
        text: 'Porovnej to s minulým týdnem',
        category: 'comparison'
      });
    }

    // Source/Campaign follow-ups
    if (queryLower.includes('banner') || queryLower.includes('google ads')) {
      suggestions.push({
        icon: 'campaign',
        text: 'Které kampaně fungují nejlépe?',
        category: 'detail'
      });
    }

    if (!queryLower.includes('konverz')) {
      suggestions.push({
        icon: 'paid',
        text: 'Kolik to přineslo konverzí?',
        category: 'conversion'
      });
    }

    // Data-based follow-ups
    if (lastData?.rows?.length > 0) {
      const hasSources = lastData.dimensions?.includes('sessionSource');
      const hasPages = lastData.dimensions?.includes('pagePath');

      if (hasSources && !queryLower.includes('stránk')) {
        suggestions.push({
          icon: 'description',
          text: 'Na kterých stránkách to funguje nejlépe?',
          category: 'detail'
        });
      }

      if (!hasSources && !queryLower.includes('zdroj')) {
        suggestions.push({
          icon: 'public',
          text: 'Odkud přišli tito uživatelé?',
          category: 'source'
        });
      }
    }

    // Generic useful follow-ups
    if (suggestions.length < 4) {
      suggestions.push({
        icon: 'schedule',
        text: 'Jak dlouho tam byli?',
        category: 'engagement'
      });
    }

    return suggestions.slice(0, 4); // Max 4 suggestions
  };

  const suggestions = generateSuggestions();

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 p-4 bg-primary/10 dark:bg-primary/5 border-2 border-primary/30 rounded-lg backdrop-blur-sm">
      <div className="text-sm text-text-light dark:text-text-dark font-bold mb-3 flex items-center gap-2">
        <span className="material-symbols-outlined text-lg">lightbulb</span>
        Možná vás zajímá:
      </div>
      <div className="flex flex-col gap-2">
        {suggestions.map((suggestion, idx) => (
          <button
            key={idx}
            className="bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark p-3 rounded-lg text-text-light dark:text-text-dark hover:bg-primary hover:text-white hover:border-primary transition-all flex items-center gap-3 text-left font-medium shadow-sm hover:shadow"
            onClick={() => onSelect(suggestion.text)}
          >
            <span className="material-symbols-outlined text-xl flex-shrink-0">
              {suggestion.icon}
            </span>
            <span className="flex-1">{suggestion.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
